import { Component, OnInit } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatCard } from '@angular/material/card';

@Component({
    selector: 'app-releasenotes',
    templateUrl: './releasenotes.component.html',
    styleUrls: ['./releasenotes.component.scss'],
    imports: [MatToolbar, MatToolbarRow, MatCard]
})
export class ReleasenotesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
